import axios from '../index'
///create crn
export default {
    getInstitucion () {
        return axios.get('/instituciones/usuario/')
    },
    getCiclosEscolares (institucionId) {
        return axios.get('/ciclos-escolares/ciclosPorInstitucion/' + institucionId)
    },
    getGrupo (institucionId, params){
        return axios.get('/grupos-administrativos/gruposInstitucion/' + institucionId, {
            params
        })
    },
}